import ServTypeStockES from '@/modules/service/views/ServTypeStockES';
import ServOp from '@/modules/service/views/ServOp';
import ServTypeServ from '@/modules/service/views/ServTypeServ';
import ServTypeServStore from '@/modules/service/views/ServTypeServStore';
import ServTeam from '@/modules/service/views/ServTeam';
import ServTeamOp from '@/modules/service/views/ServTeamOp';

import ServOrderList from '@/modules/service/views/ServOrderList';
import ServOrder from '@/modules/service/views/ServOrder';

import ProdOrderList from '@/modules/service/views/ProdOrderList';
import ProdOrder from '@/modules/service/views/ProdOrder';



export default [
	{
		path: '/servtypestockes',
		name: 'servtypestockes',
		component: ServTypeStockES,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/servop',
		name: 'servop',
		component: ServOp,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/servtypeserv',
		name: 'servtypeserv',
		component: ServTypeServ,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/servtypeservstore',
		name: 'servtypeservstore',
		component: ServTypeServStore,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/servteam',
		name: 'servteam',
		component: ServTeam,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/servteamop',
		name: 'servteamop',
		component: ServTeamOp,
		// props: (route) => ({ itemId: route.query.itemId}),
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: false,
	},
	{
		path: '/servteam/show/:itemId',
		name: 'servteamshow',
		component: ServTeamOp,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},

	{
		path: '/servorderlist',
		name: 'servorderlist',
		component: ServOrderList,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/servorder',
		name: 'servorder',
		component: ServOrder,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: false,
	},
	{
		path: '/servorder/show/:itemId',
		name: 'servordershow',
		component: ServOrder,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},

	{
		path: '/prodorderlist',
		name: 'prodorderlist',
		component: ProdOrderList,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/prodorder',
		name: 'prodorder',
		component: ProdOrder,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: false,
	},
	{
		path: '/prodorder/show/:itemId',
		name: 'prodordershow',
		component: ProdOrder,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
]